import * as Yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const createResearchFieldValidationSchema = Yup.object().shape({
  name: Yup.string().required('bonusExpenditure.validationErrors.nameRequired'),
  researchFieldId: Yup.string().required('bonusExpenditure.validationErrors.researchFieldRequired'),
  expenditure: Yup.number().required('bonusExpenditure.validationErrors.expenditureRequired').nullable(),
  startDate: Yup.date().required('bonusExpenditure.validationErrors.startDateRequired'),
  endDate: Yup.date().min(Yup.ref('startDate'), 'bonusExpenditure.validationErrors.endDateMustBeAfterStartDate').required('bonusExpenditure.validationErrors.endDateRequired'),
});
